import type { Message, SpritePosition } from '@/types'

// Case 1
// 第一个出现的角色，站在中间

// Case2
// 第二个出现的角色，将第一个角色放置在右边，然后第一个角色放置在左边

// Case3
// 第三个出现的角色，直接替换第一个角色，然后将第二个角色保持原位

// 通过角色名字匹配判断是否为同一个角色
// Case4
// Narrator出现，将所有的角色消除
export function getAvatarsPosition(
  msg: Message,
  lastPosition: SpritePosition | undefined,
): SpritePosition | undefined {
  // 如果message中的poseUrl或者name不存在，则视为未完成的message，不需要更新spritePosition
  if (!msg.name) {
    return undefined
  }

  // 如果message是narrator，将所有的位置都设置为空
  if (msg.name === 'Narrator') {
    return {
      left: { name: '', url: '', active: false, messageId: msg.messageId },
      middle: { name: '', url: '', active: false, messageId: msg.messageId },
      right: { name: '', url: '', active: false, messageId: msg.messageId },
    }
  }

  // 检查上一个位置是否存在，比如第一个Message就会出现lastPosition为undefined
  // 或者上一个message是narrator则lastPosition的所有位置都会为空
  if (lastPosition === undefined || checkLastPositionEmpty(lastPosition)) {
    return {
      left: { name: '', url: '', active: false },
      middle: { name: msg.name, url: msg.poseUrl || '', active: true, messageId: msg.messageId },
      right: { name: '', url: '', active: false },
    }
  }
  else {
    // 检查是否存在于上一个位置中的某个位置
    const foundPosition = Object.keys(lastPosition) as (keyof SpritePosition)[]
    const existingPosition = foundPosition.find(
      pos => lastPosition[pos]?.name === msg.name,
    )
    // 如果存在于上一个位置中的某个位置，将那个位置更换为新的poseUrl并且active设置为true
    // 并且将其他的位置的active设置为false
    if (existingPosition) {
      const newSpritePosition = {
        left: { ...lastPosition.left, active: false },
        middle: { ...lastPosition.middle, active: false },
        right: { ...lastPosition.right, active: false },
      }
      newSpritePosition[existingPosition] = {
        name: msg.name,
        url: msg.poseUrl || '',
        active: true,
        messageId: msg.messageId,
      }
      return newSpritePosition
    }

    // 如果不存在于之前位置中的位置，检查之前的位置是在中间，还是左边右边都会存在
    // 如果之前的位置是在中间，将之前的位置放置在右边，将新的位置放置在左边，中间的位置设置为空
    // 如果之前的位置是在左边或者右边，将lastPosition里面的isActive为true的留在原位，新的放在isActive为true这个位置的另一侧
    else {
      const isLeftOccupied = lastPosition?.left?.name !== ''
      const isRightOccupied = lastPosition?.right?.name !== ''

      if (isLeftOccupied && isRightOccupied) {
        const sideToReplace = lastPosition?.left?.active ? 'right' : 'left'
        const newSpritePosition = {
          left: { ...lastPosition.left, active: false },
          middle: { ...lastPosition.middle, active: false },
          right: { ...lastPosition.right, active: false },
        }
        newSpritePosition[sideToReplace] = {
          name: msg.name,
          url: msg.poseUrl || '',
          active: true,
          messageId: msg.messageId,
        }
        return newSpritePosition
      }
      else {
        // 如果左边和右边没有被同时占用，则lastPosition一定是中间被占用
        // 所以新的位置需要被放在屏幕的左边，而lastPosition的位置需要被放在屏幕的右边
        const newSpritePosition = {
          left: { name: msg.name, url: msg.poseUrl || '', active: true, messageId: msg.messageId },
          middle: { name: '', url: '', active: false },
          right: { ...lastPosition.middle, active: false },
        }
        return newSpritePosition
      }
    }
  }
}

function checkLastPositionEmpty(lastPosition: SpritePosition | undefined) {
  if (lastPosition === undefined) {
    return true
  }
  else {
    return Object.keys(lastPosition).every(pos => lastPosition[pos]?.name === '')
  }
}

export function checkMsgIdExist(lastPosition: SpritePosition | undefined, msgId: string) {
  if (lastPosition === undefined) {
    return false
  }
  else {
    return Object.keys(lastPosition).some(pos => lastPosition[pos]?.messageId === msgId)
  }
}
